export enum CertificateStatus {
  NoStatus = 'null',
  JustSend = 'justSent',
  Progress = 'inProgress',
  Rejected = 'rejected',
  Accepted = 'approved',
  Expired = 'expired',
}
